import type { AppPaneUnderlayViewState } from "../store/schema/AppPaneUnderlayViewState";
import getStore from "../store/store";
import { mutatorAction } from "satcheljs";

const setAppPaneUnderlayVisibilityMutator: typeof setAppPaneUnderlayVisibility = mutatorAction("setAppPaneUnderlayVisibility", setAppPaneUnderlayVisibility);

export default setAppPaneUnderlayVisibilityMutator;

function setAppPaneUnderlayVisibility(key: string, isShown: boolean, shrinkable?: boolean, isPlaceholder?: boolean, underlayViewState?: AppPaneUnderlayViewState): void {
    const store = underlayViewState || getStore();
    if (!isShown) {
        store.shrinkable.delete(key);
        store.isPlaceholder.delete(key);
    }
    else {
        store.shrinkable.set(key, shrinkable);
        store.isPlaceholder.set(key, isPlaceholder);
    }
    
    store.isShown.set(key, isShown);
}
